import { isEmergencyMode } from '../emergency';
import makeToolkitInfo from './makeToolkitInfo';
import { getCookie } from '../utils/cookie';
import commonAjax from '../utils/commonAjax';
import { validateToolkitInfo } from './validateToolkitInfo';

const host = document.location.host;
const stageApihost = 'https://stageapi.i-scream.co.kr/api/toolkit/';
const productionApihost = 'https://api.i-scream.co.kr/api/toolkit/';

const isLocal =
  host.includes('localhost') ||
  host.startsWith('127.') ||
  host.startsWith('10.') ||
  host.startsWith('192.168.');
const stagehost = 'stagetoolkit.i-scream.co.kr';

let apidomain;

if (isLocal) {
    apidomain = stageApihost;
}else if(host == stagehost){
    apidomain = stageApihost;
}else{
    apidomain = productionApihost;
}

const debounceMap = {};
const inFlightMap = {};
const lastSnapshotMap = {};
const pendingSaveMap = {};
const latestSnapshotMap = {};

// 디바운스 함수 (Promise 지원)
// function debouncePromise(func, delay) {
//     let timeoutId;
//     return function(...args) {
//         return new Promise((resolve, reject) => {
//             if (timeoutId) {
//                 clearTimeout(timeoutId);
//             }
//             timeoutId = setTimeout(async () => {
//                 try {
//                     const result = await func(...args);
//                     resolve(result);
//                 } catch (error) {
//                     reject(error);
//                 }
//             }, delay);
//         });
//     };
// }

// `fetch`를 이용한 `upsertToolkitInfo`
// const debouncedUpsertToolkitInfo = debouncePromise(async function(termsOfUse) {
//     const mId = getCookie('mId');
//     if (!mId) return Promise.reject(new Error("비로그인 상태입니다."));

//     console.error('upsertToolkitInfo v.1.3 - 툴킷 환경 데이타만 저장');

//     const toolkitInfo = makeToolkitInfo(); // toolkitInfo 생성

//     // Zod 유효성 검사 (JSON 파싱 후 검사)
//     try {
//         const parsedToolkitInfo = JSON.parse(toolkitInfo);
//         const validationResult = validateToolkitInfo(parsedToolkitInfo);

//         if (!validationResult.success) {
//             console.warn("유효하지 않은 데이터로 인해 저장이 차단되었습니다.");
//             console.error("검증 오류 상세:", validationResult.error.format()); // 상세 오류 로그 출력
//             return Promise.reject(new Error("유효하지 않은 데이터입니다."));
//         }
//     } catch (error) {
//         console.error("JSON 파싱 오류:", error);
//         return Promise.reject(new Error("데이터 형식이 올바르지 않습니다."));
//     }

//     const formData = new FormData();
//     formData.append('mId', mId);
//     formData.append('toolkitInfo', toolkitInfo);

//     if (termsOfUse) {
//         formData.append('termsOfUse', termsOfUse);
//     }

//     const url = `${apidomain}upsertToolkitInfo`;

//     try {
//         const response = await fetch(url, {
//             method: 'POST',
//             body: formData,
//         });
    
//         if (!response.ok) {
//             throw new Error("서버와의 통신 중 오류가 발생했습니다.");
//         }
    
//         const result = await response.json();
//         if (result.result === "success") {
//             console.log("데이터 저장 성공:", result);
//             return result;
//         } else {
//             throw new Error("데이터 저장 실패: " + result.resultMessage);
//         }
//     } catch (error) {
//         console.error("데이터 저장 과정에서 오류 발생:", error);
//         throw new Error("데이터 저장에 실패했습니다. 다시 시도해 주세요.");
//     }
// }, 500);

// 공통 로직: mId 확인, toolkitInfo 생성 및 검증, FormData 생성
async function processToolkitInfo(termsOfUse) {
    const mId = getCookie('mId');
    if (!mId) {
        throw new Error("비로그인 상태입니다.");
    }
    console.log('툴킷 정보 생성 및 검증 시작');
    const toolkitInfo = makeToolkitInfo();

    // JSON 파싱 및 Zod 검증
    let parsedToolkitInfo;
    try {
        parsedToolkitInfo = JSON.parse(toolkitInfo);
    } catch (error) {
        console.error("JSON 파싱 오류:", error);
        throw new Error("데이터 형식이 올바르지 않습니다.");
    }

    const validationResult = validateToolkitInfo(parsedToolkitInfo);
    if (!validationResult.success) {
        console.error("유효하지 않은 데이터입니다.", validationResult.error.format());
        throw new Error("유효하지 않은 데이터입니다.");
    }

    const formData = new FormData();
    formData.append('mId', mId);
    formData.append('toolkitInfo', toolkitInfo);
    if (termsOfUse) {
        formData.append('termsOfUse', termsOfUse);
    }

    return formData;
}

// insertToolkitInfo: 새 데이터 등록을 위한 함수
// 요청 파라미터: mId, toolkitInfo, termsOfUse
// const debouncedInsertToolkitInfo = debouncePromise(async function(termsOfUse) {
//     console.log('insertToolkitInfo')
//     const formData = await processToolkitInfo(termsOfUse);
//     const url = `${apidomain}insertToolkitInfo`;

//     try {
//         const response = await fetch(url, {
//             method: 'POST',
//             body: formData,
//         });

//         if (!response.ok) {
//             throw new Error("서버와의 통신 중 오류가 발생했습니다.");
//         }

//         const result = await response.json();
//         if (result.result === "success") {
//             console.log("등록 성공:", result);
//             return result;
//         } else {
//             throw new Error("등록 실패: " + result.resultMessage);
//         }
//     } catch (error) {
//         console.error("등록 과정에서 오류 발생:", error);
//         throw new Error("등록에 실패했습니다. 다시 시도해 주세요.");
//     }
// }, 500);

// updateToolkitInfo: 기존 데이터 수정을 위한 함수
// 요청 파라미터: mId, toolkitSequence, toolkitInfo, termsOfUse
// const debouncedUpdateToolkitInfo = debouncePromise(async function(termsOfUse) {
//     console.log('updateToolkitInfo')
//     const formData = await processToolkitInfo(termsOfUse);
    
//     // update의 경우 추가로 toolkitSequence를 파라미터에 포함해야 함.
//     const toolkitSequence = getData('toolkitSequence'); // toolkitSequence를 가져오는 방법은 상황에 맞게 수정
//     if (!toolkitSequence) {
//         throw new Error("툴킷 고유번호가 없습니다.");
//     }
//     formData.append('toolkitSequence', toolkitSequence);

//     const url = `${apidomain}updateToolkitInfo`;

//     try {
//         const response = await fetch(url, {
//             method: 'POST',
//             body: formData,
//         });

//         if (!response.ok) {
//             throw new Error("서버와의 통신 중 오류가 발생했습니다.");
//         }

//         const result = await response.json();
//         if (result.result === "success") {
//             console.log("수정 성공:", result);
//             return result;
//         } else {
//             throw new Error("수정 실패: " + result.resultMessage);
//         }
//     } catch (error) {
//         console.error("수정 과정에서 오류 발생:", error);
//         throw new Error("수정에 실패했습니다. 다시 시도해 주세요.");
//     }
// }, 500);

async function insertToolkitInfo(termsOfUse) {
    if (isEmergencyMode) return;

    if (inFlightMap["insert"]) {
        console.log("⛔ insert 중 차단");
        return;
    }

    inFlightMap["insert"] = true;

    try {

        const formData = await processToolkitInfo(termsOfUse);

        const response = await fetch(
            `${apidomain}insertToolkitInfo`,
            {
                method: 'POST',
                body: formData,
            }
        );

        if (!response.ok) {
            throw new Error("통신 오류");
        }

        const result = await response.json();

        if (result.result !== "success") {
            throw new Error(result.resultMessage);
        }

        console.log("✔ insert 완료");

    } finally {
        inFlightMap["insert"] = false;
    }
}

async function updateToolkitInfo(termsOfUse, delay = 500) {
    if (isEmergencyMode) return;

    const toolkitSequence = getData('toolkitSequence');
    
    // 🔥 비로그인 → 서버 저장 안 함
    if (!toolkitSequence) {
        console.log("비로그인 상태 → 서버 저장 생략");
        return;
    }

    const formData = await processToolkitInfo(termsOfUse);
    formData.append('toolkitSequence', toolkitSequence);

    const snapshot = formData.get('toolkitInfo');
    latestSnapshotMap[toolkitSequence] = snapshot;

    // 1️⃣ Dirty Check
    if (lastSnapshotMap[toolkitSequence] === snapshot) {
        return;
    }

    // 2️⃣ Debounce
    if (delay === 0) {
        if (debounceMap[toolkitSequence]) {
            clearTimeout(debounceMap[toolkitSequence]);
            debounceMap[toolkitSequence] = null;
        }

        if (inFlightMap[toolkitSequence]) {
            console.log("환경 저장 중 → pending 등록:", toolkitSequence);
            pendingSaveMap[toolkitSequence] = true;
            return;
        }

        inFlightMap[toolkitSequence] = true;

        try {

            const response = await fetch(
                `${apidomain}updateToolkitInfo`,
                {
                    method: 'POST',
                    body: formData,
                    keepalive: true,
                }
            );

            if (!response.ok) {
                throw new Error("통신 오류");
            }

            const result = await response.json();

            if (result.result !== "success") {
                throw new Error(result.resultMessage);
            }

            lastSnapshotMap[toolkitSequence] = snapshot;

            console.log("환경 저장 완료:", toolkitSequence);

        } finally {
            inFlightMap[toolkitSequence] = false;

            if (pendingSaveMap[toolkitSequence]) {

                pendingSaveMap[toolkitSequence] = false;

                console.log("환경 pending 재실행:", toolkitSequence);

                updateToolkitInfo(termsOfUse, 0);
            }
        }

        return;
    }

    if (debounceMap[toolkitSequence]) {
        clearTimeout(debounceMap[toolkitSequence]);
    }

    debounceMap[toolkitSequence] = setTimeout(async () => {

        // 3️⃣ In-flight Lock
        if (inFlightMap[toolkitSequence]) {
            console.log("⛔ 환경 저장 중 → pending 등록:", toolkitSequence);
            pendingSaveMap[toolkitSequence] = true;
            return;
        }

        inFlightMap[toolkitSequence] = true;

        try {

            const response = await fetch(
                `${apidomain}updateToolkitInfo`,
                {
                    method: 'POST',
                    body: formData,
                    keepalive: true,
                }
            );

            if (!response.ok) {
                throw new Error("통신 오류");
            }

            const result = await response.json();

            if (result.result !== "success") {
                throw new Error(result.resultMessage);
            }

            lastSnapshotMap[toolkitSequence] = snapshot;

            console.log("✔ 환경 저장 완료:", toolkitSequence);

        } finally {
            inFlightMap[toolkitSequence] = false;

            if (pendingSaveMap[toolkitSequence]) {

                pendingSaveMap[toolkitSequence] = false;

                console.log("🔁 환경 pending 재실행:", toolkitSequence);

                // ⭐ 최신 상태로 다시 저장
                updateToolkitInfo(termsOfUse, 0);
            }
        }

    }, delay);
}

function getData(key) {
    const item = localStorage.getItem(key);
    // "undefined" 문자열을 처리하고 null 반환
    if (item === null || item === 'undefined') {
        return null;
    }

    // 정상적으로 JSON 파싱 처리
    try {
        return JSON.parse(item);
    } catch (e) {
        console.error('JSON parse error:', e);
        return null; // 오류가 발생하면 null 반환
    }
}

// export { debouncedInsertToolkitInfo as insertToolkitInfo, debouncedUpdateToolkitInfo as updateToolkitInfo };
export {
    updateToolkitInfo,
    insertToolkitInfo
};
